// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_ct-b";
export var colorBlue = "_ct-8";
export var colorDot = "_ct-0";
export var colorDotLarge = "_ct-2";
export var colorDotSmall = "_ct-1";
export var colorGreen = "_ct-7";
export var colorGrey = "_ct-3";
export var colorOrange = "_ct-5";
export var colorPink = "_ct-a";
export var colorPurple = "_ct-9";
export var colorRed = "_ct-4";
export var colorYellow = "_ct-6";